import React from 'react';

import {ClosedEyeIcon, EyeIcon, LockIcon} from '../../icons';
import {Button} from '../Button';
import {Input} from './Input';
import {InputContainer, InputContainerProps} from './InputContainer';
import {inputIconProps} from './util';

interface Props extends Omit<InputContainerProps, 'children'> {}

export const PasswordInput: React.FC<Props> = ({invalid, ...props}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const onPress = () => setShowPassword(prev => !prev);

  const Icon = showPassword ? EyeIcon : ClosedEyeIcon;

  return (
    <InputContainer {...{invalid}}>
      <LockIcon {...inputIconProps} />

      <Input secureTextEntry={!showPassword} {...props} />

      {!!props.value && (
        <Button {...{onPress}} variant="transparent">
          <Icon {...inputIconProps} />
        </Button>
      )}
    </InputContainer>
  );
};
